module.exports = __webpack_public_path__ + "img/base_divers_voiture_electrique.882bb9df.svg";